import { render, staticRenderFns } from "./prestock-add.vue?vue&type=template&id=2a85efac"
import script from "./prestock-add.vue?vue&type=script&lang=ts"
export * from "./prestock-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports